import { request } from 'data/requests/request';

const cartButtonRequest = (productId: string) =>
    request({ type: 'cartButtonRequest', url: `priority/button/index/productId/${productId}`, notApi: true });

export default cartButtonRequest;
